<template>
    <div class="bg-weight">
        <div class="authentication-top-con" v-if="isShowTop === 1">
            <div class="authentication-top">
                <img src="https://chain-apply.oss-cn-shanghai.aliyuncs.com/operation_picture/index_renzheng_img.png" alt="">
                <button @click="runBottom"></button>
            </div>
        </div>

        <div id="target" :class="isShowTop === 0 ? 'smallAutherTication': 'autherTication'">
            <div class="title" v-if="isShowTop === 1">
                <span>认证申请</span>
                <p>填写以下表单，工作人员审核通过后，即可成为住逻辑认证设计师。带<span style="color:red">*</span>为必填内容</p>
            </div>
            <div class="main" :class="isShowTop !== 1 ? 'main-small' : ''">
                <div class="choice" v-if="user.certification === 0">
                    <span class="personTitle" :class="toggleShow ? 'activeClass' : ' '" @click="toggle">
                        <span></span>
                        <i class="iconfont icon-people"></i>
                        个人
                    </span>
                        <span class="componyTitle" :class="!toggleShow ? 'activeClass' : ' '" @click="toggle">
                        <span></span>
                         <i class="iconfont icon-housen"></i>
                        企业
                    </span>
                </div>
                <div>
                    <div v-if="user.certification !== 0">
                        <div v-if="user.certification === 1">
                            <personal-box :isShowTop="isShowTop" @isShowCheck="isShowCheck"></personal-box>
                        </div>
                        <div v-if="user.certification === 2">
                            <company-box :isShowTop="isShowTop" @isShowCheck="isShowCheck"></company-box>
                        </div>
                    </div>
                    <div v-else>
                        <div v-show="toggleShow">
                            <personal-box :isShowTop="isShowTop" @isShowCheck="isShowCheck"></personal-box>
                        </div>
                        <div v-show="!toggleShow">
                            <company-box :isShowTop="isShowTop" @isShowCheck="isShowCheck"></company-box>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </div>
</template>
<script>
    import api from '../../../api'
    import store from '../../../store'
    import myUpload from '../../common/myUpload.vue'
    import validator from '../account/validator';
    import companyBox from './company.vue'
    import personalBox from './personal.vue'
    const reg_phone = validator.reg_phone;
    export default {
        data() {
            return {
                companyData:null,
                personalData:null,
                toggleShow: true,
                marginLeft:0,
                choiceed: null

            }
        },
        computed: {
            user() {
                return this.$store.state.user.info;
            },
        },
        props: {
          isShowTop: {
              type: Number,
              default: 1
          }
        },
        components: {
            myUpload,
            companyBox,
            personalBox
        },
        mounted(){
            window.addEventListener('resize',this.getWidth);
        },
        beforeDestroy(){
            window.removeEventListener('resize',this.getWidth);
        },
        methods: {
            isShowCheck(value){
                this.choiceed = value
            },
            getScreenWidth(){
                return document.body.clientWidth;
            },
            runBottom(){
//                document.body.scrollTop = 1015;
                window.scrollTo(0, 1200);
            },
            getWidth() {
                let winWidth = window.innerWidth;
                this.marginLeft = winWidth<1800?-(1800 + 20 - winWidth)/2:0;
            },
            toggle(){
              this.toggleShow = !this.toggleShow
            },
            getVerifyIndividual() {
                api.account.getVerifyIndividual()
                    .then(res => {
                        this.personalData = res
                    })
            },
        },
        created(){
            this.getWidth();
        }
    }
</script>
<style rel="stylesheet/scss" lang="scss">
    .authentication-top-con{
        width: 100%;
        /*min-height: 1000px;*/
        background: #a1dbea;
        background: -webkit-linear-gradient(left, #a1dbea , #BAE4EC); /* Safari 5.1 - 6.0 */
        background: -o-linear-gradient(right, #a1dbea , #BAE4EC); /* Opera 11.1 - 12.0 */
        background: -moz-linear-gradient(right, #a1dbea , #BAE4EC); /* Firefox 3.6 - 15 */
        background: linear-gradient(to right, #a1dbea , #BAE4EC); /* 标准的语法 */
        .authentication-top{
            overflow: hidden;
            max-width:1800px;
            margin:0 auto;
            border:none;
            font-size:0;
            line-height:0;
            position: relative;
            text-align: center;
            >button{
                display: inline-block;
                position: absolute;
                cursor: pointer;
                height: 65px;
                width: 180px;
                top:42%;
                left: 45%;
                background: url("../../../images/renzheng1.png") 0 0 no-repeat;
            }
            >button:hover{
                opacity: 0.8;
            }
            >img{
                display: block;
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
    }

    .autherTication{
        width: 1200px;
        margin: 0px auto;
        background: #fff;
        padding-bottom: 50px;
        .main {
            width: 100%;
            padding: 36px 60px;
            .choice {
                margin-top: 0px;
            }
        }
        .title{
            width: 100%;
            padding: 40px 53px 22px 53px;
            border-bottom: 1px solid #EBEFF0;
            >span{
                font-size: 20px;
                color: #353838;
            }
            >p{
                font-size: 14px;
                color: #6C6F70;
                margin-top: 15px;
            }
        }
    }
    .smallAutherTication{
        width: 974px;
        .main{
            padding: 0;
        }
    }
    .main {
        width: 100%;
        .choice{
            margin-top: 38px;
            cursor: pointer;
            text-align: left;
            > span{
                font-size: 14px;
                color: #6C6F70;
                vertical-align: middle;
                &:hover{
                    color:#308697;
                    >span{
                        border: 3px solid #308697;
                    }
                    i{
                        color:#308697;
                    }
                }
                >span{
                    display: inline-block;
                    vertical-align: middle;
                    border: 1px solid #6C6F70;
                    width: 10px;
                    height: 10px;
                    border-radius: 50%;
                    margin-right: 5px;
                    margin-top: -3px;
                }
                i{
                    display: inline-block;
                    color: #6C6F70;
                    vertical-align: middle;
                    margin-top: -6px;
                }
            }
            .activeClass{
                color:#308697;
                >span{
                    border: 3px solid #308697;
                }
                i{
                    color:#308697;
                }
            }
            .componyTitle{
                margin-left: 28px;
            }

        }
    }
    .main-small{
        padding-left: 20px !important;
    }
</style>